var _circle, _g, _g2, _path, _path2, _path3, _g3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 242,
    viewBox: "0 0 152 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9135,
    cy: 58.7593,
    r: 58,
    fill: "#D7F1DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2876_24637)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9895 13.7088C67.4823 12.1686 78.0736 11.3971 88.6788 11.4003C99.4458 11.4003 110.022 9.88495 120.368 11.4003C129.132 12.6941 135.203 22.6723 135.203 31.2947V57.9684C135.203 66.5908 129.132 74.265 120.368 75.5588C111.675 76.831 102.912 77.5782 94.1288 77.7963C93.6869 77.805 93.2651 77.9826 92.9502 78.2926L74.4115 96.8268C73.9468 97.2909 73.3549 97.607 72.7107 97.7349C72.0665 97.8629 71.3988 97.7971 70.7919 97.5459C70.185 97.2946 69.6662 96.8691 69.3011 96.3231C68.9359 95.7772 67.128 93.8158 67.1274 93.159L68.7401 76.9545C64.8112 76.595 60.8929 76.1281 56.9895 75.5543C48.2253 74.2694 40.1025 66.5908 40.1025 57.9684L42.1551 31.2992C42.1551 22.6768 48.2253 14.9937 56.9895 13.7088Z",
    fill: "#E9F8F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2876_24637)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2526 10.2879C64.7454 8.7477 75.3367 7.97616 85.9419 7.9794C96.7089 7.9794 107.285 8.76808 117.631 10.2834C126.395 11.5772 132.466 19.2514 132.466 27.8738V54.5475C132.466 63.1699 126.395 70.8441 117.631 72.1379C108.938 73.4101 100.175 74.1573 91.3918 74.3755C90.95 74.3841 90.5282 74.5617 90.2132 74.8717L71.6746 93.4059C71.2099 93.8701 70.618 94.1861 69.9738 94.3141C69.3296 94.442 68.6618 94.3762 68.055 94.125C67.4481 93.8737 66.9293 93.4482 66.5641 92.9023C66.199 92.3563 66.0037 91.7144 66.0032 91.0575V73.5336C62.0743 73.1741 58.156 72.7072 54.2526 72.1335C45.4884 70.8485 39.4182 63.1654 39.4182 54.543V27.8783C39.4182 19.2559 45.4884 11.5728 54.2526 10.2879Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6673 40.0534L69.8638 39.4514L71.2183 40.0534V43.0638H61.6673V40.0534ZM61.9683 50.3981H58.4106L57.2066 49.714C57.2066 42.5604 58.4106 38.5442 58.4106 31.2413L70.8901 30.5571L72.3951 31.2413V34.2243H61.9683V50.3981Z",
    fill: "#94C1BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2978 50.3981L70.8901 49.714L82.8631 30.5571L84.2314 31.2413L93.0693 50.3981H89.3474L87.9944 49.714L81.931 33.1296H83.354L75.965 50.3981H72.2978ZM76.266 45.9647L77.2239 43.1733H87.5685L88.5264 45.9647H76.266Z",
    fill: "#94C1BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.215 50.6718C102.719 50.6718 101.341 50.4255 100.082 49.9329C98.8234 49.4403 97.7287 48.7561 96.7983 47.8804C95.8678 46.9864 95.1471 45.9464 94.6363 44.7605C94.1254 43.5564 93.87 42.2428 93.87 40.8197C93.87 39.3966 94.1254 38.0921 94.6363 36.9062C95.1471 35.7021 95.8678 34.6622 96.7983 33.7864C97.7287 32.8924 98.8234 32.1991 100.082 31.7065C101.341 31.2139 102.71 30.9676 104.187 30.9676C105.683 30.9676 107.052 31.2139 108.292 31.7065C109.551 32.1991 110.646 32.8833 111.576 33.759C112.507 34.6348 113.228 35.6747 113.738 36.8789C114.249 38.083 114.505 39.3966 114.505 40.8197C114.505 42.2428 114.249 43.5564 113.738 44.7605C113.228 45.9647 112.507 47.0046 111.576 47.8804C110.646 48.7561 109.551 49.4403 108.292 49.9329C107.052 50.4255 105.693 50.6718 104.215 50.6718ZM110.454 54.5853C109.779 54.5853 109.122 54.5032 108.484 54.339C107.864 54.193 107.243 53.9376 106.623 53.5727C106.021 53.226 105.391 52.7608 104.735 52.177C104.078 51.6114 103.357 50.909 102.573 50.0697L106.349 49.0845C106.86 49.7596 107.344 50.2978 107.8 50.6992C108.274 51.1188 108.73 51.4198 109.168 51.6023C109.606 51.7847 110.062 51.8759 110.536 51.8759C111.64 51.8759 111.774 50.4985 112.625 49.714L113.82 50.3434L115.462 52.3138C114.185 53.8281 112.516 54.5853 110.454 54.5853ZM104.187 47.552C105.154 47.552 106.048 47.3878 106.869 47.0594C107.69 46.731 108.402 46.2657 109.004 45.6637C109.606 45.0433 110.071 44.3227 110.4 43.5017C110.746 42.6807 110.92 41.7867 110.92 40.8197C110.92 39.8345 110.746 38.9405 110.4 38.1378C110.071 37.3167 109.606 36.6052 109.004 36.0031C108.402 35.3828 107.69 34.9085 106.869 34.5801C106.048 34.2516 105.154 34.0874 104.187 34.0874C103.22 34.0874 102.326 34.2516 101.505 34.5801C100.684 34.9085 99.9728 35.3828 99.3707 36.0031C98.7687 36.6052 98.2943 37.3167 97.9477 38.1378C97.6193 38.9405 97.4551 39.8345 97.4551 40.8197C97.4551 41.7867 97.6193 42.6807 97.9477 43.5017C98.2943 44.3227 98.7687 45.0433 99.3707 45.6637C99.9728 46.2657 100.684 46.731 101.505 47.0594C102.326 47.3878 103.22 47.552 104.187 47.552Z",
    fill: "#94C1BC"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2876_24637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5992 32.8574V38.6865H69.8493V41.6969H60.5992V49.0312H57.0415V29.8744H71.026V32.8574H60.5992ZM86.0627 44.5978H76.4842L74.5959 49.0312H70.9288L79.5493 29.8744H83.0523L91.7003 49.0312H87.9784L86.0627 44.5978ZM84.8859 41.8064L81.2735 33.4321L77.6884 41.8064H84.8859ZM114.093 50.9469C113.455 51.6949 112.707 52.2605 111.849 52.6437C111.01 53.0268 110.089 53.2184 109.085 53.2184C107.772 53.2184 106.568 52.9173 105.473 52.3153C104.378 51.7314 103.128 50.7097 101.724 49.2502C99.9539 49.1042 98.3666 48.5933 96.9618 47.7176C95.5569 46.8236 94.4623 45.6651 93.6777 44.242C92.8932 42.8007 92.501 41.2043 92.501 39.4528C92.501 37.5918 92.9479 35.9133 93.8419 34.4173C94.7359 32.903 95.9674 31.7262 97.5365 30.8869C99.1055 30.0295 100.866 29.6007 102.818 29.6007C104.77 29.6007 106.531 30.0295 108.1 30.8869C109.669 31.7262 110.901 32.8939 111.795 34.3899C112.689 35.886 113.136 37.5736 113.136 39.4528C113.136 40.9671 112.835 42.3719 112.233 43.6673C111.63 44.9444 110.791 46.0391 109.715 46.9513C108.638 47.8453 107.389 48.493 105.965 48.8944C106.495 49.46 107.015 49.8705 107.525 50.1259C108.036 50.3813 108.584 50.509 109.167 50.509C110.426 50.509 111.521 49.9982 112.451 48.9765L114.093 50.9469ZM96.086 39.4528C96.086 40.7299 96.3779 41.8885 96.9618 42.9284C97.5456 43.9501 98.3484 44.7529 99.3701 45.3367C100.392 45.9023 101.541 46.1851 102.818 46.1851C104.095 46.1851 105.245 45.9023 106.267 45.3367C107.288 44.7529 108.091 43.9501 108.675 42.9284C109.259 41.8885 109.551 40.7299 109.551 39.4528C109.551 38.1757 109.259 37.0263 108.675 36.0046C108.091 34.9646 107.288 34.1619 106.267 33.5963C105.245 33.0124 104.095 32.7205 102.818 32.7205C101.541 32.7205 100.392 33.0124 99.3701 33.5963C98.3484 34.1619 97.5456 34.9646 96.9618 36.0046C96.3779 37.0263 96.086 38.1757 96.086 39.4528Z",
    fill: "#55857E"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3878 72.9758L93.4667 78.1072",
    stroke: "white",
    strokeOpacity: 0.05,
    strokeWidth: 0.684173
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2876_24637",
    x: 33.2608,
    y: 6.62178,
    width: 108.783,
    height: 100.755,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.73669
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.42087
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.341176 0 0 0 0 0.360784 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2876_24637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2876_24637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2876_24637",
    x: 32.5764,
    y: 3.87435,
    width: 106.731,
    height: 100.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.73669
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.42087
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.341176 0 0 0 0 0.360784 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2876_24637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2876_24637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2876_24637",
    x: 54.3049,
    y: 29.6007,
    width: 62.5253,
    height: 29.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.73669
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.36835
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.817083 0 0 0 0 0.883333 0 0 0 0 0.874257 0 0 0 0.77 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2876_24637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2876_24637",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.ee38f5a560993dd111ceaaeacecb8e8e.svg";
export { ForwardRef as ReactComponent };